import { Input } from "@vds/inputs";
import { Loader } from "@vds/loaders";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import BaseModal from "../../../global/components/Modals/BaseModal";
import { updateCameraOnboaredReq } from "../../../store/actions";
import {
  RTSP_VALIDATION_CONSTANTS,
  validateRtspUrl,
  extractRtspUrlComponents
} from "../../../constants/rtspValidationConstants";
import { safeDecodeURIComponent } from "../../../global/utility/devicesUtils";
const ManualCameraRtspUrl = ({
  rtspUrls,
  setOpenModal,
  openModal,
  cameraDetails,
  companionDetails,
}) => {
  const dispatch = useDispatch();

  const [inputFields, setInputFields] = useState([]);
  const [loading, setLoading] = useState(false);

  const { cameraUpdateStatus } = useSelector((state) => state.deviceReducer);

  const [submitError, setSubmitError] = useState(null);
  const [rtspErrors, setRtspErrors] = useState({});
  const [isFormValid, setIsFormValid] = useState(false);

  // Validate all RTSP URLs
  const validateAllUrls = (fields) => {
    const errors = {};
    let hasErrors = false;

    fields.forEach((item, index) => {
      const url = item?.customdata?.encoders?.[0]?.url;
      if (url) {
        // Validate the encoded URL directly - regex checks structure, not content
        const error = validateRtspUrl(url);
        if (error) {
          errors[index] = error;
          hasErrors = true;
        }
      } else {
        errors[index] = RTSP_VALIDATION_CONSTANTS.ERRORS.URL_REQUIRED;
        hasErrors = true;
      }
    });

    setRtspErrors(errors);
    setIsFormValid(!hasErrors);
    return !hasErrors;
  };


  useEffect(() => {
    if (cameraUpdateStatus && Object.keys(cameraUpdateStatus).length) {
      setOpenModal(false);
      setLoading(false);
      setSubmitError(null);
      setRtspErrors({});
    }
  }, [cameraUpdateStatus]);

  const handleClose = () => {
    setOpenModal(false);
    setRtspErrors({});
    setSubmitError(null);
  };

  useEffect(() => {
    setInputFields(rtspUrls);
    if (rtspUrls && rtspUrls.length > 0) {
      validateAllUrls(rtspUrls);
    }
  }, [rtspUrls]);

  const handleSubmit = () => {
    if (loading) return;

    if (!validateAllUrls(inputFields)) {
      setSubmitError(RTSP_VALIDATION_CONSTANTS.ERRORS.INVALID_URL);
      return;
    }

    try {
      const fovsurl = rtspUrls[0]?.customdata?.encoders[0]?.url;
      setLoading(true);
      setSubmitError(null);

      if (fovsurl) {
        // extractRtspUrlComponents now handles decoding internally
        const components = extractRtspUrlComponents(fovsurl);

        if (!components) {
          throw new Error(RTSP_VALIDATION_CONSTANTS.ERRORS.INVALID_FORMAT_GENERAL);
        }

        const payload = {
          userName: components.username,
          pass: components.password,
          companionQrcode: companionDetails[0]?.qrcode,
          cameraDetailsId: cameraDetails?.qrcode,
          fovData: inputFields
        };
        dispatch(updateCameraOnboaredReq(payload));
      } else {
        throw new Error(RTSP_VALIDATION_CONSTANTS.ERRORS.URL_NOT_FOUND);
      }
    } catch (error) {
      setSubmitError(error.message || RTSP_VALIDATION_CONSTANTS.ERRORS.ERROR_PROCESSING);
      setLoading(false);
    }
};

  const handleFormChange = (index, event) => {
    event.preventDefault();
    let data = [...inputFields];
    const rawUrl = event.target.value;
    data[index]["customdata"]["encoders"][0][event.target.name] = rawUrl;
    setInputFields(data);

    if (rawUrl) {
      // Validate the encoded URL directly - regex checks structure, not credential content
      const error = validateRtspUrl(rawUrl);
      setRtspErrors(prev => ({
        ...prev,
        [index]: error || ""
      }));

      setTimeout(() => validateAllUrls(data), 0);
    }
  };
  return (
    <>
      {loading && <Loader active={true} fullscreen={true} disableFocusLock />}
      <BaseModal
        opened={openModal}
        title="RTSP URLs"
        closeButtonText={"Cancel"}
        primaryButtonText={"Submit"}
        onBack={handleClose}
        onClose={handleClose}
        onCloseButtonClick={handleSubmit}
        disabled={!isFormValid || loading}
        width="560px"
      >
        {submitError && (
          <div className="manual-rtsp__error-banner">
            {submitError}
          </div>
        )}
        
        {rtspUrls &&
          rtspUrls.map((item, index) => {
            const currentError = rtspErrors[index] || "";
            return (
              <div key={index} className="manual-rtsp__input-row">
                <Input
                  type="text"
                  label={`Stream ${index + 1}: RTSP URL`}
                  name="url"
                  placeholder=""
                  required={true}
                  value={safeDecodeURIComponent(item?.customdata?.encoders[0]?.url) || ""}
                  width="100%"
                  helperText={RTSP_VALIDATION_CONSTANTS.HELPER_TEXT}
                  helperTextPlacement="bottom"
                  errorText={currentError}
                  error={currentError ? true : false}
                  onChange={(event) => handleFormChange(index, event, item?.customdata?.encoders)}
                />
              </div>
            );
          })}
      </BaseModal>
    </>
  );
};

export default ManualCameraRtspUrl;
